import { FC } from 'react';
import { faCheck, faTimes } from '@fortawesome/pro-light-svg-icons';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { Icon } from '@app/components';

import './FormFieldRequirementIndicator.scss';

interface FormFieldRequirementIndicatorProps {
  isValid: boolean;
  message: string;
}

const cnBem = createBemBlockBuilder(['formFieldRequirementIndicator']);

export const FormFieldRequirementIndicator: FC<
  FormFieldRequirementIndicatorProps
> = ({ message, isValid }) => (
  <div data-auto="form-field-requirement-indicator" className={cnBem()}>
    <Icon icon={isValid ? faCheck : faTimes} />
    {message}
  </div>
);
